import { CustomIconProps } from 'assets/Icons/LibraryIcon';
import React from 'react';

const SpeedIcon: React.FC<CustomIconProps> = ({
  width,
  height,
  fill,
  ...rest
}) => {
  return (
    <svg
      width={width ?? 40}
      height={height ?? 40}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M20.0007 6.66406C10.8107 6.66406 3.33399 14.1407 3.33399 23.3307C3.33183 25.903 3.93172 28.4401 5.08566 30.7391C5.36899 31.3057 5.94566 31.6641 6.57732 31.6641H33.4223C34.054 31.6641 34.6323 31.3057 34.9157 30.7391C36.0696 28.4401 36.6695 25.903 36.6673 23.3307C36.6673 14.1407 29.1907 6.66406 20.0007 6.66406ZM32.3507 28.3307H7.65066C6.99938 26.7443 6.66531 25.0456 6.66732 23.3307C6.66732 15.9791 12.649 9.9974 20.0007 9.9974C27.3523 9.9974 33.334 15.9791 33.334 23.3307C33.336 25.0456 33.0019 26.7443 32.3507 28.3307Z'
        fill={fill ?? 'white'}
      />
      <path
        d='M18.2325 21.5647C17.8779 21.7966 17.5867 22.1131 17.3852 22.4857C17.1837 22.8583 17.0781 23.2752 17.0781 23.6989C17.0781 24.1225 17.1837 24.5394 17.3852 24.912C17.5867 25.2847 17.8779 25.6012 18.2325 25.833C18.5126 26.0174 18.8264 26.1446 19.1558 26.2075C19.4852 26.2704 19.8237 26.2678 20.1521 26.1996C20.4805 26.1315 20.7922 25.9993 21.0693 25.8106C21.3465 25.6218 21.5838 25.3803 21.7675 25.0997L28.3708 15.0364C28.3761 15.0276 28.3789 15.0175 28.3789 15.0072C28.3789 14.9969 28.3761 14.9868 28.3708 14.978C28.363 14.966 28.3507 14.9575 28.3367 14.9544C28.3227 14.9513 28.308 14.9538 28.2958 14.9614L18.2325 21.5647Z'
        fill={fill ?? 'white'}
      />
    </svg>
  );
};

export default SpeedIcon;
